import { imageLoader } from "@/lib/sanity/client";
import Image from "next/image";
import { useState } from "react";
import { useRouter } from "next/router";
import {
  CardContainerContest,
  CardInfo,
  Details,
  EndsOn,
  ImageContainerContest,
  Label,
  LabelWrapper,
  Prize,
  StatusLabel,
  Title,
} from "./styles";
import { useTranslation } from "@/lib/translations";

export type ContestProps = {
  variant: "contest";
  title?: string;
  contestUrl?: string;
  endsOn?: string; // date?
  prize?: string;
  image?: {
    asset?: Record<string, any>;
  };
  fadeInCursorAction: any,
  fadeOutCursorAction: any,
};

const Contest: React.FC<ContestProps> = (props) => {
  const { title, endsOn, contestUrl, prize, image } = props;
  const { locale = "it" } = useRouter();
  const t = {
    contestDeadline: useTranslation("contestStatus.deadline", locale),
    contestPrize: useTranslation("contestStatus.prize", locale),
    contestOpen: useTranslation("contestStatus.open", locale),
    contestClosed: useTranslation("contestStatus.closed", locale),
  };

  const [isLoaded, setIsLoaded] = useState(false);
  // Check if today's date is smaller than the contest date
  const checkActive = () => {
    if (endsOn) {
      return new Date() < new Date(endsOn) ? true : false;
    }
  };
  const isActive = checkActive();

  const getDate = (str: string) => {
    if (!str) return "";
    const day = new Date(str).toLocaleString("default", {
      day: "2-digit",
    });
    const month = new Date(str).toLocaleString("default", {
      month: "long",
    });
    const year = new Date(str).toLocaleString("default", {
      year: "numeric",
    });
    const endDate = `${day} ${month} ${year}`;
    return endDate;
  };

  return (
    <CardContainerContest>
      {title && (
        <Title as="a" href={contestUrl || "/"} target="_blank"
        onMouseEnter={() => props.fadeOutCursorAction()}
        onMouseLeave={() => props.fadeInCursorAction()}
        >
          <h3>{title}</h3>
        </Title>
      )}
      <ImageContainerContest $isLoaded={isLoaded}>
        {image && image?.asset && image.asset?.url && (
          <Image
            sizes="(max-width: 768px) 75vw, 40vw"
            src={image.asset?.url}
            layout="fill"
            objectFit="cover"
            loader={imageLoader}
            onLoadingComplete={() => setIsLoaded(true)}
            alt="" // TODO: can we have a value for this?
          />
        )}
      </ImageContainerContest>
      <CardInfo>
        {/*         {title && <Title>{title}</Title>}
         */}{" "}
        <Details>
          {endsOn && (
            <LabelWrapper>
              <Label>{t.contestDeadline}</Label>
              <EndsOn>{getDate(endsOn)}</EndsOn>
            </LabelWrapper>
          )}
          {prize && (
            <LabelWrapper>
              <Label>{t.contestPrize}</Label>
              <Prize>{prize}</Prize>
            </LabelWrapper>
          )}
          {endsOn && (
            <StatusLabel $isActive={isActive}>
              {isActive ? t.contestOpen : t.contestClosed}
            </StatusLabel>
          )}
        </Details>
      </CardInfo>
    </CardContainerContest>
  );
};

export default Contest;
